export default __webpack_public_path__ + "static/media/selected4.01bdbf7f.png";